import { QueryClient } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { Outlet, createRootRouteWithContext } from '@tanstack/react-router';

import { useReportStaleChunkReload } from '../shared/lib/useReportStaleChunkReload';
import { ErrorPage } from '../shared/ui/ErrorPage';
import { RouteChangeAnalyticsTracker } from '../shared/ui/RouteChangeAnalyticsTracker';
import { TanStackRouterDevtoolsOnlyDev } from '../shared/ui/TanStackRouterDevtoolsOnlyDev';

export const Route = createRootRouteWithContext<{ queryClient: QueryClient }>()(
  {
    component: Root,
    errorComponent: ErrorPage,
    notFoundComponent: () => {
      return <h2>404 Not Found</h2>;
    },
  },
);

function Root() {
  // Sends the row for a reload that escaped a stale chunk, now that there is a
  // document to send it from. The failed branch is reported by `ErrorPage`,
  // which is what renders instead of this when the reload changed nothing.
  useReportStaleChunkReload();

  return (
    <>
      <Outlet />
      <RouteChangeAnalyticsTracker />
      <ReactQueryDevtools buttonPosition="bottom-right" />
      <TanStackRouterDevtoolsOnlyDev position="bottom-left" />
    </>
  );
}
